export enum methods {
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  GET = "GET"
}
